<template>
  <table
    class="table table-bordered"
    style="width: 100%;">
    <thead>
      <tr>
        <th style="min-width: 130px;">{{ $t('message.date') }}</th>
        <th>{{ $t('message.cashier') }}</th>
        <th class="text-center">{{ $t('apps.pos.message.possession') }}</th>
        <th class="text-center">{{ $t('message.transactions') }}</th>
        <th class="text-center">{{ $t('message.product') }}</th>
        <th class="text-center">{{ $t('message.new_customers') }}</th>
        <th class="text-center">{{ $t('message.old_customers') }}</th>
        <th
          v-if="getRoleMetadata.view.fields.net"
          class="text-right"
        >
          {{ $t('message.net') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.profit"
          class="text-right"
        >
          {{ $t('message.profit') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) in rows"
        :key="`row-${index}`"
      >
        <td
          v-if="item.index === 0"
          :rowspan="item.rowspan"
        >
          {{ item.date }}
        </td>
        <td>{{ item.name }}</td>
        <td class="text-center">{{ getNumber(item.sessionsCount) }}</td>
        <td class="text-center">{{ getNumber(item.transactionsCount) }}</td>
        <td class="text-center">{{ getNumber(item.productsCount) }}</td>
        <td class="text-center">{{ getNumber(item.newCustomersCount) }}</td>
        <td class="text-center">{{ getNumber(item.oldCustomersCount) }}</td>
        <td
          v-if="getRoleMetadata.view.fields.net"
          class="text-right"
        >
          {{ getNumber(item.net) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.profit"
          class="text-right"
        >
          {{ getNumber(item.profit) }}
        </td>
      </tr>
      <tr
        v-for="(item, index) in summary"
        :key="`summary-${index}`"
      >
        <td
          v-if="index === 0"
          :rowspan="summary.length"
        >
          {{ $t('apps.reports.message.total') }}
        </td>
        <td>{{ item.name }}</td>
        <td class="text-center">{{ getNumber(item.sessionsCount) }}</td>
        <td class="text-center">{{ getNumber(item.transactionsCount) }}</td>
        <td class="text-center">{{ getNumber(item.productsCount) }}</td>
        <td class="text-center">{{ getNumber(item.newCustomersCount) }}</td>
        <td class="text-center">{{ getNumber(item.oldCustomersCount) }}</td>
        <td
          v-if="getRoleMetadata.view.fields.net"
          class="text-right"
        >
          {{ getNumber(item.net) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.profit"
          class="text-right"
        >
          {{ getNumber(item.profit) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],

  props: ['items'],

  computed: {
    rows () {
      return this.items.reduce((acc, cur) => {
        const cashiers = cur.cashiers.map((cashier, index) => {
          return {
            ...cashier,
            date: cur.date,
            index: index,
            rowspan: cur.cashiers.length,
            name: cashier.name,
          }
        })
        return acc = acc.concat(cashiers)
      }, [])
    },
    summary () {
      const cashiersNames = this.items.reduce((acc, cur) => {
        for (const cashier of cur.cashiers) {
          if (!acc.includes(cashier.name)) {
            acc.push(cashier.name)
          }
        }
        return acc
      }, [])
      return cashiersNames.reduce((acc, cur) => {
        const init = {
          name: cur,
          sessionsCount: 0,
          transactionsCount: 0,
          productsCount: 0,
          newCustomersCount: 0,
          oldCustomersCount: 0,
          net: 0,
          profit: 0,
        }

        for (const item of this.items) {
          for (const cashier of item.cashiers) {
            if (cashier.name === cur) {
              init.sessionsCount += cashier.sessionsCount
              init.transactionsCount += cashier.transactionsCount
              init.productsCount += cashier.productsCount
              init.newCustomersCount += cashier.newCustomersCount
              init.oldCustomersCount += cashier.oldCustomersCount
              init.net += cashier.net
              init.profit += cashier.profit
            }
          }
        }

        return acc.push(init) && acc
      }, [])
        .sort(function (a, b) {
          return parseFloat(b.profit) - parseFloat(a.profit)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/ReportCashierTable.vue